import { useRouter } from 'next/router'
import { H1, P1 } from '@moneymade/moneymade-ui'

import ImgLazy from 'components/ui/ImgLazy/ImgLazy'
import { getCdnImg } from 'utils/getters'
import styles from './BottomImages.module.scss'

const BottomImages = () => {
  const { push } = useRouter()

  return (
    <section className={styles.BottomImages}>
      <div className={styles.Block} onClick={() => push('/')} onKeyDown={() => {}} tabIndex="0" role="button">
        <div className={styles.LeftSide}>
          <H1>
            <span className={styles.White}>DO MORE WITH YOUR </span>
            <span className={styles.Black}>MONEY.</span>
          </H1>
          <P1>
            <span className={styles.White}>RIDE WITH US </span>
          </P1>
        </div>

        <div className={styles.RightSide}>
          <ImgLazy
            alt="banner"
            src={getCdnImg('https://assets.moneymade.io/images/collections/bannerImg.png', 309)}
            width={309}
            height={206}
          />
        </div>
      </div>
    </section>
  )
}

export default BottomImages
